import React from "react";
import { Source, Layer } from "react-map-gl";

// const geojsonOptions = {
//   //   id: "data",
//   type: "fill",
//   paint: {
//     "fill-color": "red",
//     "fill-opacity": 0.5
//   }
// };

const lineOptions = lineColor => {
  return {
    type: "line",
    paint: {
      "line-color": lineColor,
      "line-width": 3
    }
  };
};

export const GeojsonLayer = ({ layer, i, lineColor }) => (
  <Source key={`whattt-${i}`} type="geojson" data={layer}>
    <Layer {...lineOptions(lineColor)} id={`what-${i}`} />
  </Source>
);
